export const AdsTxtStatusConst = ({
    ADI: {
        id: 0,
        label: 'Authorized Direct Inventory',
        exist: false
    },
    ARI: {
        id: 1,
        label: 'Authorized Reseller Inventory',
        exist: false
    },
    UI: {
        id: 2,
        label: 'Unmeasurable Inventory',
        exist: false
    }
});